module.exports = __webpack_public_path__ + "static/media/corrin-lose.e2a84e31.png";